export interface IdType {
  id: number;
  name: string;
  category: string;
  sample: string[];
  hasBackOfId: boolean;
  hasExpiry: boolean;
}

export const advancedPages: string[] = [
  'poi',
  'upload-id',
  'upload-selfie',
  'business-info',
];

export const idTypes: IdType[] = [
  {
    id: 1,
    name: 'Voter’s ID',
    category: 'primary',
    sample: ['../../../assets/images/sample-ids/comelec-id.png'],
    hasBackOfId: false,
    hasExpiry: false,
  },
  {
    id: 2,
    name: 'Driver’s License',
    category: 'primary',
    sample: ['../../../assets/images/sample-ids/drivers-license-front.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 3,
    name: 'PhilSys ID (National ID)',
    category: 'primary',
    sample: [
      '../../../assets/images/sample-ids/nat-id-front.png',
      '../../../assets/images/sample-ids/nat-id-back.png',
    ],
    hasBackOfId: true,
    hasExpiry: false,
  },
  {
    id: 4,
    name: 'PhilSys ID (e-PhilID)',
    category: 'primary',
    sample: [
      '../../../assets/images/sample-ids/phylsis-front.png',
      '../../../assets/images/sample-ids/phylsis-back.png',
    ],
    hasBackOfId: true,
    hasExpiry: false,
  },
  {
    id: 5,
    name: 'Passport',
    category: 'primary',
    sample: [
      '../../../assets/images/sample-ids/passport-front.png',
      '../../../assets/images/sample-ids/passport-back.png',
    ],
    hasBackOfId: true,
    hasExpiry: true,
  },
  {
    id: 6,
    name: 'PRC',
    category: 'primary',
    sample: [
      '../../../assets/images/sample-ids/prc-nurse.png',
      '../../../assets/images/sample-ids/prc-back.png',
    ],
    hasBackOfId: true,
    hasExpiry: true,
  },
  {
    id: 7,
    name: 'SSS/GSIS',
    category: 'primary',
    sample: ['../../../assets/images/sample-ids/sss.png'],
    hasBackOfId: false,
    hasExpiry: false,
  },
  {
    id: 8,
    name: 'UMID',
    category: 'primary',
    sample: ['../../../assets/images/sample-ids/umid.png'],
    hasBackOfId: false,
    hasExpiry: false,
  },
  {
    id: 9,
    name: 'AFP ID',
    category: 'secondary',
    sample: ['../../../assets/images/sample-ids/afp-id.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 10,
    name: 'BFP ID',
    category: 'secondary',
    sample: ['../../../assets/images/sample-ids/bfp-id.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 11,
    name: 'DSWD Certification',
    category: 'secondary',
    sample: [
      '../../../assets/images/sample-ids/dswd-travel-clearance-01.png',
      '../../../assets/images/sample-ids/dswd-travel-clearance-02.png',
    ],
    hasBackOfId: true,
    hasExpiry: true,
  },
  {
    id: 12,
    name: 'GSIS e-Card',
    category: 'secondary',
    sample: ['../../../assets/images/sample-ids/gsis.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 13,
    name: 'OFW ID',
    category: 'secondary',
    sample: ['../../../assets/images/sample-ids/ofw-ecard.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 14,
    name: 'Police Clearance',
    category: 'secondary',
    sample: ['../../../assets/images/sample-ids/police-clearance.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 15,
    name: 'Postal ID',
    category: 'primary',
    sample: ['../../../assets/images/sample-ids/postal-id.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 16,
    name: 'PWD ID',
    category: 'secondary',
    sample: ['../../../assets/images/sample-ids/pwd-id.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 17,
    name: "Seaman's Book",
    category: 'secondary',
    sample: [
      '../../../assets/images/sample-ids/seamans-book-01.png',
      '../../../assets/images/sample-ids/seamans-book-back.png',
    ],
    hasBackOfId: true,
    hasExpiry: true,
  },
  {
    id: 18,
    name: 'ACR / Immigrant COR',
    category: 'primary',
    sample: [
      '../../../assets/images/sample-ids/acr-front.png',
      '../../../assets/images/sample-ids/acr-back.png',
    ],
    hasBackOfId: true,
    hasExpiry: true,
  },
  {
    id: 19,
    name: 'PNP ID',
    category: 'secondary',
    sample: ['../../../assets/images/sample-ids/pnp-id.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
  {
    id: 20,
    name: 'NBI Clearance',
    category: 'secondary',
    sample: ['../../../assets/images/sample-ids/nbi-clearance.png'],
    hasBackOfId: false,
    hasExpiry: true,
  },
];

// IDs no longer accepted
// {
//   id: 19,
//   name: 'PSA Birth Certificate',
//   category: 'secondary',
//   sample: ['../../../assets/images/sample-ids/psa-bc.png'],
//   hasBackOfId: false,
//   hasExpiry: false,
// },
// {
//   id: 23,
//   name: 'TIN ID',
//   category: 'secondary',
//   sample: ['../../../assets/images/sample-ids/tin-id.png'],
//   hasBackOfId: false,
//   hasExpiry: false,
// },
// {
//   id: 8,
//   name: 'Student ID',
//   category: 'primary',
//   sample: [
//     '../../../assets/images/sample-ids/student-id-front.jpg',
//     '../../../assets/images/sample-ids/student-id-back.jpg',
//   ],
//   hasBackOfId: true,
//   hasExpiry: true,
// },
// {
//   id: 10,
//   name: 'Barangay Certificate',
//   category: 'secondary',
//   sample: ['../../../assets/images/sample-ids/barangay-clearance.png'],
//   hasBackOfId: false,
//   hasExpiry: true,
// },
// {
//   id: 11,
//   name: 'Barangay ID/ Barangay Residents Identification',
//   category: 'secondary',
//   sample: ['../../../assets/images/sample-ids/barangay-id.png'],
//   hasBackOfId: false,
//   hasExpiry: true,
// },
// {
//   id: 22,
//   name: 'Senior Citizen ID',
//   category: 'secondary',
//   sample: ['../../../assets/images/sample-ids/senior-id.png'],
//   hasBackOfId: false,
//   hasExpiry: false,
// },
